export const enum Authorization {
    GoNoGo = 'gonogo'
}